import _ from "lodash";
import { map } from "ramda";
import * as React from "react";
import { connect } from "react-redux";
import { State } from "src/state";
import { AccountPresenterKind } from "../model/presenter/types";
import { deselectCells, selectCell } from "../model/selectedCells/actions";
import { enterMappingMode, exitMappingMode } from "../model/spread/actions";
import { getMappingNodeId } from "../model/spread/selector";
import { RuleChangeLog, RuleHistory } from "../model/spread/types";
import HiddenAccountRow from "./HiddenAccountRow";
import { getTagConfig } from "./Tag/selector";
import TagRow from "./Tag/TagRow";
import { TagConfig } from "./Tag/types";
import ValueAccountRow from "./ValueAccountRow";

interface ValueAccountSectionProps {
  account: AccountPresenterKind<"VALUE">;
  hierarchyLevel: number;
  mappingNodeId: string | null;
  enterMappingMode: typeof enterMappingMode;
  exitMappingMode: typeof exitMappingMode;
  selectCell: typeof selectCell;
  deselectCells: typeof deselectCells;
  ruleHistory: RuleHistory;
  initialChangelog: RuleChangeLog;
  periods: string[];
  tagConfig: TagConfig;
}

interface ValueAccountSectionState {
  expanded: boolean;
}

export class ValueAccountSection extends React.Component<
  ValueAccountSectionProps,
  ValueAccountSectionState
> {
  constructor(props: ValueAccountSectionProps) {
    super(props);
    this.state = { expanded: true };
  }

  public onToggleHiddenAccounts = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  public handleRemapClick = () => {
    if (this.props.mappingNodeId === this.props.account.id) {
      this.props.exitMappingMode();
    } else {
      this.props.enterMappingMode(this.props.account.id);
    }
  };

  public hasHiddenAccounts = () => {
    return (
      _.filter(
        this.props.account.children,
        child =>
          child.periodValues[0] ||
          child.periodValues[1] ||
          child.periodValues[0] === 0 ||
          child.periodValues[1] === 0
      ).length > 0
    );
  };

  public render() {
    const {
      account,
      hierarchyLevel,
      ruleHistory,
      initialChangelog
    } = this.props;

    return (
      <React.Fragment>
        <div className="ValueAccountSection">
          <ValueAccountRow
            expanded={
              this.state.expanded || this.props.mappingNodeId === account.id
            }
            account={account}
            key={account.id}
            hasHiddenAccounts={this.hasHiddenAccounts()}
            onToggleHiddenAccounts={this.onToggleHiddenAccounts}
            hierarchyLevel={hierarchyLevel}
            handleRemapClick={this.handleRemapClick}
            mappingNodeId={this.props.mappingNodeId}
            periods={this.props.periods}
          />
          {(this.state.expanded || this.props.mappingNodeId === account.id) &&
            map(
              child => {
                return (
                  (child.periodValues[0] ||
                    child.periodValues[0] === 0 ||
                    child.periodValues[1] ||
                    child.periodValues[1] === 0) && (
                    <HiddenAccountRow
                      account={child}
                      hierarchyLevel={hierarchyLevel + 1}
                      key={child.id}
                      isHighlighted={this.props.mappingNodeId === account.id}
                      ruleHistory={ruleHistory}
                      initialChangelog={initialChangelog}
                      periods={this.props.periods}
                      parentUserEditedValues={account.userEditedByPeriod}
                    />
                  )
                );
              },
              account.children as Array<AccountPresenterKind<"HIDDEN">>
            )}
          {this.props.tagConfig.parentNodeId === account.id && (
            <TagRow
              key={account.id + "tag"}
              account={account}
              hierarchyLevel={hierarchyLevel + 1}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: State) => ({
  mappingNodeId: getMappingNodeId(state),
  tagConfig: getTagConfig(state)
});

export default connect(
  mapStateToProps,
  {
    enterMappingMode,
    exitMappingMode,
    selectCell,
    deselectCells
  }
)(ValueAccountSection);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/ValueAccountSection.tsx